import { studentConstants } from '../constants';

const initialState = {
    loading: false,
    students: [],
    error: null,
    creatingStudents: false,
    createError: null,
    updatingStudents: false,
    updateError: null,
    deleting: false,
    deleted: false
};

const studentReducer = (state = initialState, action) => {
    switch (action.type) {
        case studentConstants.FETCH_STUDENTS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case studentConstants.FETCH_STUDENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                students: action.students,
                error: null
            };
        case studentConstants.FETCH_STUDENTS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case studentConstants.CREATE_STUDENTS_REQUEST:
            return {
                ...state,
                creatingStudents: true,
                createError: null,
            };
        case studentConstants.CREATE_STUDENTS_SUCCESS:
            return {
                ...state,
                creatingStudents: false,
                students: action.students
            };
        case studentConstants.CREATE_STUDENTS_FAILURE:
            return {
                ...state,
                creatingStudents: false,
                createError: action.error,
            };
        case studentConstants.UPDATE_STUDENTS_REQUEST:
            return {
                ...state,
                updatingStudents: true,
                updateError: null,
            };
        case studentConstants.UPDATE_STUDENTS_SUCCESS:
            return {
                ...state,
                updatingStudents: false,
                students: action.students
            };
        case studentConstants.UPDATE_STUDENTS_FAILURE:
            return {
                ...state,
                updatingStudents: false,
                updateError: action.error,
            };
        case studentConstants.DELETE_STUDENT_REQUEST:
            return {
                ...state,
                deleting: true,
                deleted: false
            };
        case studentConstants.DELETE_STUDENT_SUCCESS:
            return {
                ...state,
                deleting: false,
                deleted: true,
                students: state.
                    students
                    .filter(student => student.StudentProfileID !== action.payload)
            };
        case studentConstants.DELETE_STUDENT_FAILURE:
            return {
                ...state,
                deleting: false,
                deleted: false,
                error: action.error
            };
        case studentConstants.UPDATE_ACCESSCODE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case studentConstants.UPDATE_ACCESSCODE_SUCCESS:
            return {
                ...state,
                loading: false,
                students: state.students.map(student => {
                    if (student.StudentProfileID === action.accesscode.StudentProfileID) {
                        return { ...student, AccessCode: action.accesscode.AccessCode, LoggedInStatus: "Y" };
                    }
                    return student;
                })
            };
        case studentConstants.UPDATE_ACCESSCODE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        default:
            return state;
    }
};

export default studentReducer;
